import { BaseService, BaseServiceConstructor } from 'api/services/base.service';
import {
  CommunicationEventDTO,
  CommunicationMethod,
  CommunicationProgram,
  CommunicationRefusalReason,
  CommunicationResponseType,
  CreateBulkPropertyCommunicationEvent,
  PropertyCommunicationEventDTO,
  UpdateCommunicationEvent,
  UpdatePropertyCommunicationEvent,
} from '@cast/leadcast-types';

export class CommunicationService extends BaseService {
  constructor({ serviceUrls, token, tenantName }: BaseServiceConstructor) {
    super({ serviceUrls, token, tenantName });
  }

  async getCommunicationPrograms(): Promise<CommunicationProgram[]> {
    const { data } = await this.publicHttpClient.get<CommunicationProgram[]>(
      `/communications/communicationPrograms`,
      {
        withCredentials: false,
      }
    );
    return data;
  }

  async getCommunicationMethods(): Promise<CommunicationMethod[]> {
    const { data } = await this.publicHttpClient.get<CommunicationMethod[]>(
      `/communications/communicationMethods`,
      {
        withCredentials: false,
      }
    );
    return data;
  }

  async getCommunicationResponseTypes(): Promise<CommunicationResponseType[]> {
    const { data } = await this.publicHttpClient.get<CommunicationResponseType[]>(
      `/communications/communicationResponseTypes`,
      {
        withCredentials: false,
      }
    );
    return data;
  }

  async getCommunicationRefusalReasons(): Promise<CommunicationRefusalReason[]> {
    const { data } = await this.publicHttpClient.get<CommunicationRefusalReason[]>(
      `/communications/communicationRefusalReasons`,
      {
        withCredentials: false,
      }
    );
    return data;
  }

  async createSyncBulkCommunicationEvent({
    communicationEventForProperty,
    propertyIds,
  }: CreateBulkPropertyCommunicationEvent): Promise<
    CommunicationEventDTO & Partial<PropertyCommunicationEventDTO>
  > {
    const { data } = await this.publicHttpClient.post<
      CommunicationEventDTO & Partial<PropertyCommunicationEventDTO>
    >(
      `/communications/properties`,
      {
        communicationEventForProperty,
        propertyIds,
      },
      {
        withCredentials: false,
      }
    );

    return data;
  }

  async createAsyncBulkCommunicationEvent({
    communicationEventForProperty,
    propertyIds,
  }: CreateBulkPropertyCommunicationEvent): Promise<{ jobId: string }> {
    const { data } = await this.publicHttpClient.post<{ jobId: string }>(
      `/communications/properties/async`,
      {
        communicationEventForProperty,
        propertyIds,
      },
      {
        withCredentials: false,
      }
    );
    return data;
  }

  async updateCommunicationEvent(
    communicationEventId: CommunicationEventDTO['id'],
    communicationEvent: UpdateCommunicationEvent
  ): Promise<void> {
    await this.publicHttpClient.put<void>(
      `/communications/${communicationEventId}`,
      communicationEvent,
      {
        withCredentials: false,
      }
    );
  }

  async updatePropertyCommunicationEvent(
    propertyCommunicationEventId: PropertyCommunicationEventDTO['id'],
    propertyCommunicationEvent: UpdatePropertyCommunicationEvent
  ): Promise<void> {
    await this.publicHttpClient.put<void>(
      `/communications/properties/${propertyCommunicationEventId}`,
      propertyCommunicationEvent,
      {
        withCredentials: false,
      }
    );
  }
}
